import Modal from '@/customComponents/uiComponents/modal/Modal.jsx'
import ModalHeader from '@/customComponents/uiComponents/modal/ModalHeader.jsx'
import {
    flightDelayIcon, infinityIcon,
    perkReliableIcon, perkHoldFundsIcon, perkFlatRateIcon, perkChildSeatsIcon, perkCancellationIcon, perkLuggageIcon,
    playButton, arrowLongDown
} from '@img/index.js'

export default function AirportPickupPerksPopup({isOpen, onClose}) {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalHeader title="Airport Pickup Perks" onClose={onClose}/>
            <h3 className="font-bold text-2xl mb-4!">Exclusive Airport Pickup Perks</h3>

            <div className="bg-(--accent-green-light) p-5 mb-5">
                <h5 className="font-semibold mb-3!">Flight Delayed? No Problem:</h5>
                <div className="flex items-start gap-3 mb-3">
                    <img src={flightDelayIcon} alt="" className="w-6 h-6 shrink-0 mt-0.5"/>
                    <span className="text-sm leading-relaxed">Hop'n tracks your flight and adjusts your pickup time automatically. Whether it's a flight delay or baggage hold-up, we've got you covered. Simply choose "By flight arrival" and let your captain ensure a smooth pickup experience</span>
                </div>
                <div className="flex items-start gap-3">
                    <img src={infinityIcon} alt="" className="w-6 h-6 shrink-0 mt-0.5"/>
                    <span className="text-sm leading-relaxed">Lost baggage? Customs or immigration delays? No worries—your driver will wait as long as needed</span>
                </div>
            </div>

            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5 list-none pl-0 mb-5">
                <li className="flex items-center gap-4">
                    <span className="shrink-0 w-14 h-14 flex items-center justify-center"><img src={perkReliableIcon} alt="" className="w-full h-full object-contain"/></span>
                    <span className="leading-snug">Guaranteed 20+ years of reliable pickup</span>
                </li>
                <li className="flex items-center gap-4">
                    <span className="shrink-0 w-14 h-14 flex items-center justify-center"><img src={perkHoldFundsIcon} alt="" className="w-full h-full object-contain"/></span>
                    <span className="leading-snug">We Hold funds and charge after drop-off</span>
                </li>
                <li className="flex items-center gap-4">
                    <span className="shrink-0 w-14 h-14 flex items-center justify-center"><img src={perkFlatRateIcon} alt="" className="w-full h-full object-contain"/></span>
                    <span className="leading-snug">Flat Fixed Rate. No surge or per km per minute charges</span>
                </li>
                <li className="flex items-center gap-4">
                    <span className="shrink-0 w-14 h-14 flex items-center justify-center"><img src={perkChildSeatsIcon} alt="" className="w-full h-full object-contain"/></span>
                    <span className="leading-snug">FREE child car seats</span>
                </li>
                <li className="flex items-center gap-4">
                    <span className="shrink-0 w-14 h-14 flex items-center justify-center"><img src={perkCancellationIcon} alt="" className="w-full h-full object-contain"/></span>
                    <span className="leading-snug">Cancellation & Changes 1 hour before pickup</span>
                </li>
                <li className="flex items-center gap-4">
                    <span className="shrink-0 w-14 h-14 flex items-center justify-center"><img src={perkLuggageIcon} alt="" className="w-full h-full object-contain"/></span>
                    <span className="leading-snug">Luggage assistance</span>
                </li>
            </ul>

            <div className="bg-(--bg-grey) rounded-2xl p-5 mb-5">
                <h5 className="font-semibold mb-3! text-sm">hop'n Exclusive Airport Pickup Perks</h5>
                <ul className="list-disc pl-5 mb-0! space-y-1.5 text-sm">
                    <li>Stay Comfortable: Relax in a heated or air-conditioned terminal while your driver picks you up right at the door</li>
                    <li>No Waiting in Line: Skip the queues and the airport chaos with our seamless service</li>
                    <li>Child Car Seats Available: Your family's safety is always our top priority</li>
                </ul>
            </div>

            <div className="flex items-center gap-4 bg-(--accent-green-light) p-2 pl-3">
                <img src={playButton} alt="" className="shrink-0"/>
                <div className="flex-1 min-w-0">
                    <strong className="block text-sm">How do I find my driver at the airport?</strong>
                    <span className="text-xs">Here's a guide on where to proceed</span>
                </div>
                <button type="button" className="cursor-pointer w-8 h-8 shrink-0 rounded-full bg-white border border-(--text-primary) flex items-center justify-center p-0">
                    <img src={arrowLongDown} alt="arrow" />
                </button>
            </div>
        </Modal>
    )
}
